module.exports = __webpack_public_path__ + "media/application/images/2023/01_still-925x520-8acb92b8437fbf0358b496429e9b885d.png";